
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anki-practice-tests",
      function () {
        return require("private-next-pages/anki-practice-tests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anki-practice-tests"])
      });
    }
  